var _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMerge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 36",
    d: "M202 142a60.068 60.068 0 00-60 60v10h40v-10a20.023 20.023 0 0120-20h8v-40z",
    fill: "#5222f2"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 37",
    d: "M452 142h-82V60a60.068 60.068 0 00-60-60H60A60.068 60.068 0 000 60v250a60.068 60.068 0 0060 60h82v82a60.068 60.068 0 0060 60h250a60.068 60.068 0 0060-60V202a60.068 60.068 0 00-60-60zm20 310a20.023 20.023 0 01-20 20H202a20.023 20.023 0 01-20-20V330H60a20.023 20.023 0 01-20-20V60a20.023 20.023 0 0120-20h250a20.023 20.023 0 0120 20v122h122a20.023 20.023 0 0120 20z",
    fill: "#5222f2"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 41",
    fill: "#5222f2",
    d: "M142 230h40v82h-40z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 42",
    fill: "#5222f2",
    d: "M230 142h80v40h-80z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 38",
    d: "M330 300v10a20.023 20.023 0 01-20 20h-8v40h8a60.068 60.068 0 0060-60v-10z",
    fill: "#5222f2"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 43",
    fill: "#5222f2",
    d: "M330 200h40v82h-40z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 44",
    fill: "#5222f2",
    d: "M201 330h82v40h-82z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerge);
export default __webpack_public_path__ + "static/media/merge.2c0749cfa5560ddf07c54bf13f6817f0.svg";
export { ForwardRef as ReactComponent };